
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h3><i class="fa-solid fa-globe me-2"></i>Länder ({{totalEntries}})</h3>
</div>

<button type="button" class="btn btn-primary mb-3" [routerLink]="['/country/detail', 0]">Land anlegen</button>

<pagination
        [hidden]="entries?.length === 0"
        [totalItems]="totalEntries"
        [itemsPerPage]="paginConfig.itemsPerPage"
        [(ngModel)]="paginConfig.page"
        (pageChanged)="listEntries($event)"
        [maxSize]="20"
        previousText="Letzte"
        nextText="Nächste"
/>

<div class="table-responsive">
    <table *ngIf="entries?.length > 0" class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th style="width: 150px" (click)="setOrder('short')">
                Kürzel <i class="fas" *ngIf="predicate === 'short'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th style="width: 150px" (click)="setOrder('name')">
                Name <i class="fas" *ngIf="predicate === 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th style="width: 150px" (click)="setOrder('locations')">
                # Standorte <i class="fas" *ngIf="predicate === 'locations'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of entries" [routerLink]="['/country/detail', entry.id]">
            <td>{{ entry.short }}</td>
            <td>{{ entry.name }}</td>
            <td>{{ entry.locations }}</td>
        </tr>
        </tbody>
    </table>
</div>
